import { Injectable, inject } from '@angular/core';
import { FormArray } from '@angular/forms';
import { RequestService } from '@seu-services';
import {
  SEU_API_ENDPOINTS,
  SeuComputationCombination,
  SeuComputationCombinationApi,
  SeuFormGroupCalculation,
} from '@seu-types';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ComputationCombinationService {
  private readonly requestService = inject(RequestService);

  public async saveComputationCombinations(
    offerId: string,
    formArray: FormArray<SeuFormGroupCalculation>
  ): Promise<void> {
    const computationCombinations: SeuComputationCombinationApi[] =
      formArray.value.map((formGroup) => {
        return {
          // convert to number
          interconnectionId: formGroup.interconnectionVersion
            ? Number(formGroup.interconnectionVersion)
            : null,
          globalParameterSetId: formGroup.globalSettings
            ? Number(formGroup.globalSettings)
            : null,
          operatingConditionIds: formGroup.operatingConditions
            ? formGroup.operatingConditions.map((operatingCondition) =>
                Number(operatingCondition)
              )
            : [],
        };
      });

    const endpoint = SEU_API_ENDPOINTS.calculationCombinations.replace(
      ':offerId',
      offerId
    );

    await firstValueFrom(
      this.requestService.put<void, SeuComputationCombinationApi[]>(
        endpoint as SEU_API_ENDPOINTS,
        computationCombinations
      )
    );
  }

  public async loadComputationCombinations(
    offerId: string
  ): Promise<SeuComputationCombination[]> {
    const endpoint = SEU_API_ENDPOINTS.calculationCombinations.replace(
      ':offerId',
      offerId
    );

    const responseData = await firstValueFrom(
      this.requestService.get<SeuComputationCombinationApi[]>(
        endpoint as SEU_API_ENDPOINTS
      )
    );

    return responseData.map((computationCombination) => {
      return {
        interconnectionId: computationCombination.interconnectionId
          ? String(computationCombination.interconnectionId)
          : null,
        globalParameterSetId: computationCombination.globalParameterSetId
          ? String(computationCombination.globalParameterSetId)
          : null,
        operatingConditionIds: computationCombination.operatingConditionIds
          ? computationCombination.operatingConditionIds.map(
              (operatingCondition) => String(operatingCondition)
            )
          : [],
      };
    });
  }
}
